module.exports = __webpack_public_path__ + "static/media/Girls-Bed4.7bb66b8a.webp";